define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./phoneNumberProviderActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, PhoneNumberProviderActions) {
    "use strict";
    var PhoneNumberProviders = /** @class */ (function () {
        function PhoneNumberProviders() {
            this.actions = new PhoneNumberProviderActions();
            this.canExport = UserContext.hasAccess("Admin,PhoneNumberProviders.Export");
            this.filterByAny = ko.observable("");
        }
        PhoneNumberProviders.prototype.init = function () {
            var self = this;
            $("#page-title").text("Tasks");
            tools.ajaxGet({
                url: "/PhoneNumberProviders/GetPhoneNumberProvidersLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.phoneNumberProvidersLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.phoneNumberProvidersLookupLists.GridStructures.PhoneNumberProvidersStructure);
                    $("#main-container").on("click", ".js-new-phone-number-provider", function (event) {
                        self.actions.editPhoneNumberProvider();
                        event.preventDefault();
                    });
                    self.actions.saveCallback = function (resultData) {
                        if (resultData) {
                            window.location.assign("/PhoneNumberProviders/Details/" + resultData.Id);
                        }
                    };
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        PhoneNumberProviders.prototype.initGrid = function (gridStructure) {
            var _this = this;
            var self = this;
            var columns = gridStructure.columns;
            var actions = {
                field: "",
                width: "65px",
                template: function (dataItem) {
                    var html = "";
                    html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"/PhoneNumberProviders/Details/".concat(dataItem.Id, "\"><i class=\"fa fa-edit \"></i></a>");
                    if (UserContext.hasAccess("Admin,PhoneNumberProviders.Delete")) {
                        html += "&nbsp;<button class=\"btn btn-sm btn-danger btn-remove\" href=\"#\"><i class=\"fa fa-trash-o \"></i></button>";
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.phoneNumberProvidersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/PhoneNumberProviders/GetPhoneNumberProviders",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#phoneNumberProviders-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                allowBulkEdits: {
                    enabled: true,
                },
                enableExport: {
                    entityName: "PhoneNumberProvider",
                    title: "PhoneNumberProviders",
                    enablePdf: false
                },
                gridId: "tblPhoneNumberProvidersKendo",
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.phoneNumberProvidersTable.initGrid(gridOptions);
            if (UserContext.hasAccess("Admin") || UserContext.hasAccess("PhoneNumberProviders.Delete")) {
                $("#tblPhoneNumberProvidersKendo tbody").on("click", ".btn-remove", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                    _this.actions.deleteNumberProviderConfirm(dataItem.Id, dataItem.Name);
                    event.preventDefault();
                });
            }
            self.actions.deleteCallback = function () {
                self.phoneNumberProvidersTable.getGridData().dataSource.read();
                if (self.dataLogs) {
                    self.dataLogs.refreshLogs();
                }
            };
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.phoneNumberProvidersTable.getGridData().dataSource.read();
            });
        };
        PhoneNumberProviders.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        PhoneNumberProviders.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.phoneNumberProvidersTable.exportTo();
            }
        };
        PhoneNumberProviders.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("PhoneNumberProvider");
                dataLogs.open("Providers logs");
                event.preventDefault();
            }
        };
        return PhoneNumberProviders;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/PhoneNumberProviders/Index")) {
            log.log("Initialize PhoneNumberProviders list");
            $(function () {
                (new PhoneNumberProviders()).init();
            });
        }
    }, 0);
    return PhoneNumberProviders;
});
//# sourceMappingURL=phoneNumberProviders.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumberProviders/phoneNumberProviders.js
// module id = 238
// module chunks = 2